<template>
  <div
    class="akr-title titleCustom w-100 bg-title"
    :class="showTitle ? 'd-flex' : 'd-none'"
  >
    <v-container fluid>
      <v-row align="center" justify="space-between" no-gutters>
        <v-col class="bt-left d-flex align-center pl-1">
          <h4
            class="white--text text--lighten-1 text-uppercase text-subtitle-2"
          >
            {{ title }}
          </h4>
        </v-col>

        <v-col class="bt-right d-flex justify-end">
          <div class="d-flex justify-center align-center">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <div class="d-flex align-center">
                  <span
                    class="white--text text-subtitle-2 font-weight-bold mr-2"
                    >Hi, {{ shortUserName }}...
                  </span>
                  <v-btn v-bind="attrs" v-on="on" icon>
                    <v-avatar size="30">
                      <img src="../images/profile.png" alt="Profile" />
                    </v-avatar>
                  </v-btn>
                </div>
              </template>

              <v-list
                dense
                class="text-right rounded-lg pa-3"
                :class="{
                  'dark-bg': $vuetify.theme.dark,
                  'light-bg': !$vuetify.theme.dark,
                }"
              >
                <v-list-item class="text-caption font-weight-bold">
                  <span class="text-uppercase">{{ user.nama_user }}</span>
                </v-list-item>
                <v-list-item class="text-caption font-weight-bold">
                  <span>{{ user.branch_name }}</span>
                </v-list-item>
                <v-list-item class="text-caption font-weight-bold">
                  <span>{{ userRole.role_name }}</span>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item @click="doLogout">
                  <v-list-item-title>
                    <span
                      class="pa-2 text-caption font-weight-bold text-uppercase"
                      >Keluar</span
                    >
                    <v-icon class="ml-2" color="purple lighten-1"
                      >mdi-logout</v-icon
                    >
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { deleteData } from "@/utils/indexedDB";
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    title: String,
  },
  computed: {
    ...mapGetters(["user", "userRole"]),

    showTitle() {
      return (
        this.$route.name &&
        !["Login", "Forgot", "Register"].includes(this.$route.name)
      );
    },

    shortUserName() {
      return this.user.nama_user?.split(" ")[0] ?? "";
    },
  },
  methods: {
    ...mapActions(["logout"]),

    async doLogout() {
      await deleteData("user_data", "user");
      this.logout();

      if (this.$route.path !== "/login") {
        this.$router.push("/login");
      }
    },
  },
};
</script>

<style scoped>
.dark-bg {
  background-color: rgba(24, 24, 24, 0.9);
}

.light-bg {
  background-color: rgba(255, 255, 255, 0.9);
}

.v-overlay__scrim {
  backdrop-filter: blur(10px);
  background-color: rgba(0, 0, 0, 0.3) !important;
}
</style>
